const scope = typeof global === 'undefined' ? window : global;

// Polyfill for withResolvers from
// https://github.com/ungap/with-resolvers/blob/main/index.js
Promise.withResolvers ||
  (Promise.withResolvers = function withResolvers() {
    var a,
      b,
      c = new this(function (resolve, reject) {
        a = resolve;
        b = reject;
      });
    return { resolve: a, reject: b, promise: c };
  });

// TODO: Scope all of these with repo name (e.g., __WEB_ZEPHR_DEV__)
scope.__DEV__ = process.env.NODE_ENV === 'development';
scope.__TEST__ = process.env.NODE_ENV === 'test';
scope.__PROD__ = process.env.NODE_ENV === 'production';
